/**
 * GlobalProgressBar — barra delgada arriba del header durante mutations
 * (paquete AA).
 *
 * Estilo YouTube/GitHub: 2px de alto, color naranja institucional, animación
 * de "indeterminate" porque no conocemos el progreso real de la mutation.
 * Se activa cuando `useIsMutating()` > 0 (cualquier mutation de TanStack
 * Query: despacho, recepción, cancelar, anular, sincronizar, etc.).
 *
 * Pequeño delay antes de aparecer (200ms): si la mutation responde rápido
 * (mock con ~250ms), no parpadea por nada.
 */

import { useEffect, useState } from 'react';
import { useIsMutating } from '@tanstack/react-query';

export function GlobalProgressBar() {
  const isMutating = useIsMutating();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isMutating > 0) {
      // Pequeño delay para evitar flash en mutations muy rápidas
      const t = window.setTimeout(() => setVisible(true), 200);
      return () => clearTimeout(t);
    }
    // Apagar inmediatamente cuando termina
    setVisible(false);
    return undefined;
  }, [isMutating]);

  if (!visible) return null;

  return (
    <div
      className="pointer-events-none fixed left-0 right-0 top-0 z-50 h-0.5 overflow-hidden bg-everex-naranja/10"
      role="progressbar"
      aria-label="Operación en curso"
    >
      <div className="global-progress-bar h-full bg-everex-naranja" />
    </div>
  );
}
